import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import JobList from './JobList'
import BatchList from './BatchList'

const useStyles = makeStyles({
  jobs: {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'row',
    '& > main': {
      flex: '1 0',
      minWidth: '30rem'
    },
    '& > section': {
      flex: '0 0 auto',
      minWidth: '26rem'
    }
  }
})

const JobsIndex = () => {
  const classes = useStyles()

  return (
    <article className={classes.jobs}>
      <main>
        <JobList />
      </main>
      <section>
        <BatchList />
      </section>
    </article>
  )
}

export default JobsIndex
